import { takeEvery, call, put } from 'redux-saga/effects';

import { getCustomizeLastQuestion } from 'pages/MyAccount/services/api/sale';
import { getUserAvatar } from 'pages/MyAccount/services/api/account';
import {
  USER,
  fetchUserAvatarSuccess,
  fetchUserAvatarError,
} from 'pages/MyAccount/services/actions/userActions';
import {
  requestCustomizeLastQuestion,
  receiveCustomizeLastQuestion,
  receiveCustomizeLastQuestionError,
} from 'pages/MyAccount/services/actions/customizeActions';

const { FETCH_USER_AVATAR_REQUEST } = USER;

export function* fetchUserAvatar() {
  try {
    const data = yield call(getUserAvatar);
    yield put(fetchUserAvatarSuccess(data && data.userAvatarUrl));
  } catch (error) {
    yield put(fetchUserAvatarError(error));
  }
}
export function* fetchCustomizeLastQuestion() {
  try {
    yield put(requestCustomizeLastQuestion());
    const data = yield call(getCustomizeLastQuestion);
    yield put(receiveCustomizeLastQuestion(data.id, data.experimentInfo));
  } catch (error) {
    yield put(receiveCustomizeLastQuestionError(error));
  }
}

// watcher sagas
export function* watchFetchBaseData() {
  yield takeEvery(FETCH_USER_AVATAR_REQUEST, fetchUserAvatar);
}
